import type { DepositClabesTranslations } from "../interfaces/depositClabes";

export const depositClabesTranslations: DepositClabesTranslations = {
  // Page
  page_title: "Deposit CLABEs",
  page_subtitle: "Receiving accounts for SPEI deposits (Mexico)",
  why_banner:
    "Without a registered CLABE, the organization's SPEI deposits cannot be attributed or credited.",
  no_org_prompt: "Select an organization to see its CLABEs.",

  // Org selector
  org_label: "Organization",
  org_placeholder: "Search organization…",
  org_loading: "Loading organizations…",
  org_empty: "No organizations found.",
  org_error: "We could not load the organizations.",
  org_truncated: "There are more organizations than shown; refine the search by name.",

  // List
  list_title: "Registered CLABEs",
  filter_placeholder: "Filter by CLABE or note…",
  filter_no_results: "No CLABE matches the filter.",
  empty_title: "No CLABEs registered",
  empty_description: "Register the first receiving account to enable this organization's SPEI deposits.",
  error_load: "We could not load the organization's CLABEs.",
  error_retry: "Retry",
  registered_at: "Registered on",
  note_label: "Note",
  status_active: "Active",
  status_inactive: "Inactive",
  flavor_static: "Static",
  flavor_dynamic: "Dynamic",
  copy_aria: "Copy",
  copy_success: "Copied to clipboard",

  // Register dialog
  button_register: "Register CLABE",
  dialog_title: "Register deposit CLABE",
  dialog_description: "The receiving account will be linked to the selected organization.",
  dialog_org_label: "Organization",
  dialog_account_label: "CLABE",
  dialog_account_placeholder: "6461 8011 1122 2233 33",
  dialog_account_helper: "18 digits, no spaces or dashes.",
  dialog_note_label: "Note (optional)",
  dialog_note_placeholder: "e.g. main receiving CLABE",
  dialog_cancel: "Cancel",
  dialog_submit: "Register",
  validation_account: "The CLABE must be exactly 18 digits.",
  hint_already_registered: "This CLABE is already registered for this organization.",
  toast_registered: "CLABE registered",
  toast_already_registered: "This CLABE was already registered for the organization",
  error_cross_org:
    "This CLABE is already assigned to another organization. A CLABE can only be active for one organization at a time.",
  error_no_write_permission: "You do not have permission to register deposit CLABEs.",
  error_register: "We could not register the CLABE.",

  // Detail drawer
  drawer_title: "CLABE detail",
  drawer_section_details: "Details",
  drawer_section_metadata: "Metadata",
  drawer_id: "ID",
  drawer_reference: "Reference",
  drawer_created: "Registered",
  drawer_updated: "Updated",
};
